import React from "react";
import "./Help.css";
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faLink} from "@fortawesome/free-solid-svg-icons";

class Help extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoCollapsable: Array(4).fill(true)
    };
  }

  render() {
    const { t } = this.props;
    return (
      <Container>
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <h4>{t("Help.Title")}</h4>
                <Table>
                  <tbody>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t("Help.BootLernstickWindows.Title")}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>{t("Help.BootLernstickWindows.Title")}</b>
                      <p>{t("Help.BootLernstickWindows.Description")}</p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.students.bootLernstickWindows} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t("Help.BootLernstickAppleSilicon.Title")}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>{t("Help.BootLernstickAppleSilicon.Title")}</b>
                      <p>{t("Help.BootLernstickAppleSilicon.Description")}</p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.students.bootLernstickAppleSilicon} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t("Help.BootLernstickMacOS.Title")}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>{t("Help.BootLernstickMacOS.Title")}</b>
                      <p>{t("Help.BootLernstickMacOS.Description")}</p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.students.bootLernstickMacOS} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t("Help.PrepareExamination.Title")}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>{t("Help.PrepareExamination.Title")}</b>
                      <p>{t("Help.PrepareExamination.Description")}</p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.students.prepareExamination} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td width="80px">
                      <img
                          alt={t("Help.DoExamination.Title")}
                          src="/images/example/campla.png"
                      />
                    </td>
                    <td>
                      <b>{t("Help.DoExamination.Title")}</b>
                      <p>{t("Help.DoExamination.Description")}</p>
                    </td>
                    <td width="50px">
                      <a href={window.helpVideos.students.doExamination} target="_blank">
                        <Button
                            className="btn btn-green"
                            size="sm"
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </Button>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {typeof window["helpLinks"] !== "undefined" && Array.isArray(window["helpLinks"]) && window["helpLinks"].length > 0 ? (
            <Row className="mt-2">
              <Col>
                <Card>
                  <Card.Body>
                    <h4>{t("Help.Links")}</h4>
                    <ul>
                      {window["helpLinks"]
                          .filter(i => typeof i["name"] !== "undefined" && typeof i["link"] !== "undefined")
                          .map(i => (
                              <li>
                                <a href={i["link"]} target="_blank">{i["name"]}</a>
                              </li>
                          ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
        ) : ""}
      </Container>
    );
  }
}


export default withTranslation()(Help);
